import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { IssueInfo } from '../model/issue.model';
import { IssueDocumentInfo } from '../model/issuedocument.model';
import { ProjectInfo } from '../model/project.model';
import { EmpInfo } from '../model/emp.model';
import { ContactlistInfo } from '../model/contactlist.model';
import { TeamInfo } from '../model/team.model';
import { LookupInfo } from '../model/lookup.model';
import {
  HttpClient,
  HttpHeaders,

  HttpEventType
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as XLSX from "xlsx";
import { TokenService } from '../service/token.service';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

let today = new Date().toISOString()

export interface PeriodicElement {
  name: string;
  position: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: "Hydrogen", symbol: "H" },
  { position: 2, name: "Helium", symbol: "He" },
  { position: 3, name: "Lithium", symbol: "Li" },
  { position: 4, name: "Beryllium", symbol: "Be" },
  { position: 5, name: "Boron", symbol: "B" },
  { position: 6, name: "Carbon", symbol: "C" },
  { position: 7, name: "Nitrogen", symbol: "N" },
  { position: 8, name: "Oxygen", symbol: "O" },
  { position: 9, name: "Fluorine", symbol: "F" },
  { position: 10, name: "Neon", symbol: "Ne" }
];

export class summarydetailInfo {
  ActionOwner: string
  IssueOwnerCode: string
  IssueAmount: number
  PriorityHigh: number
  PriorityMedium: number
  PriorityLow: number
  SeverityHigh: number
  SeverityMedium: number
  SeverityLow: number
  IssueOwnerNickName:string
}

export class summaryInfo {
  sumSeverityL: number
  sumSeverityM: number
  sumSeverityH: number
  sumSeverityNotSet: number

  sumPriorityL: number
  sumPriorityM: number
  sumPriorityH: number
  sumPriorityNotSet: number

  sumStatusOpen: number
  sumStatusInprogress: number
  sumStatusClosed: number
  sumStatusNew: number
  sumStatusHold: number


  sumSeverityLList: summarydetailInfo[]
  sumSeverityMList: summarydetailInfo[]
  sumSeverityHList: summarydetailInfo[]
  sumSeverityNotSetList: summarydetailInfo[]

  sumPriorityLList: summarydetailInfo[]
  sumPriorityMList: summarydetailInfo[]
  sumPriorityHList: summarydetailInfo[]
  sumPriorityNotSetList: summarydetailInfo[]

  SeverityLList: IssueInfo[]
  SeverityMList: IssueInfo[]
  SeverityHList: IssueInfo[]
  SeverityNotSetList: IssueInfo[]

  PriorityLList: IssueInfo[]
  PriorityMList: IssueInfo[]
  PriorityHList: IssueInfo[]
  PriorityNotSetList: IssueInfo[]


  PriorityDetailHList: IssueInfo[]
  PriorityDetailMList: IssueInfo[]
  PriorityDetailLList: IssueInfo[]

  SeverityDetailHList: IssueInfo[]
  SeverityDetailMList: IssueInfo[]
  SeverityDetailLList: IssueInfo[]
}

@Component({
  selector: 'app-issue-management',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './issue-management.component.html',
  styleUrls: ['./issue-management.component.css']
})
export class IssueManagementComponent implements OnInit {
  // Pie
  // Pie
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    }
  };

  now = new Date();
  nowFormatted: string;
  IssueId: number

  modalDocName: string;
  modalDocInfo: any;
 
  IssueForm: FormGroup;
  displayloading: boolean = false;
  Msgloadding: string = '';
  titlemodal: string
  detailmodal: string
  public body: string;
  IssuePromise: Promise<IssueInfo[]>
  issueList: IssueInfo[]
  issueListAll: IssueInfo[]

  StatusList: LookupInfo[]
  ProjectList: ProjectInfo[]
  LookupPromise: Promise<LookupInfo[]>
  SeverityList: LookupInfo[]
  PriorityList: LookupInfo[]
  IssueTypeList: LookupInfo[]
  IssueStatusList: LookupInfo[]
  IssueOwnerList: ContactlistInfo[]
  RaiseByList: ContactlistInfo[]
  dataSource = new MatTableDataSource<IssueInfo>();
  displayColumns = ['name'];
  summaryInfo = new summaryInfo;

  // Zone pagination variable
  public currentIssuePageNumber: number
  public LookupTotal: number
  public totalIssuePages: number
  //public environment: number

  txtTargetCompletionDate: string
  txtCurrentProgress: string
  lblCurrentProgress: string
  txtResolutionPlan: string
  txtDescription: string

  ddlSearchIssueStatus: string
  ddlSearchPriority: string
  ddlSearchIssueOwner: string
  ddlSearchSeverity: string
  ddlSearchRaiseBy: string
  ddlSearchIssueType: string
  ddlIssueStatus: string
  txtDateraise: string
  txtDuedate: string
  ddlRaiseby: string
  ddlIssueOwner: string
  ddlPriority: string
  ddlSeverity: string
  ddlIssueType :string
  txtTitle: string
  inputuploadfile: string
  hidIssueId: number
  hidIssueIddetail: number
  flagexpandIssue: boolean = false;
  _ParamProjectCode: string
  _ParamProjectName: string
  ProjectNameText: string
  public currentPageNumber: number
  public totalPages: number
  IssueTotal: any
  IssueSummaryTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;
  filesToUpload: File[]
  resultUploadfile: any;
  linkdowloadfile: string;
  displayfilename: string;
  panelOpenState: any;
  panelOpenStateIssue: any;


  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: [],
    },
  ];


  public currentPageNumberPriorityH: number
  public currentPageNumberPriorityM: number
  public currentPageNumberPriorityL: number

  public totalPagesPriorityH: number
  public totalPagesPriorityM: number
  public totalPagesPriorityL: number

  public totalIssuePriorityH: any
  public totalIssuePriorityM: any
  public totalIssuePriorityL: any

  public currentPageNumberSeverityH: number
  public currentPageNumberSeverityM: number
  public currentPageNumberSeverityL: number

  public totalPagesSeverityH: number
  public totalPagesSeverityM: number
  public totalPagesSeverityL: number

  public totalIssueSeverityH: any
  public totalIssueSeverityM: any
  public totalIssueSeverityL: any

  public indexNoPriorityH: number
  public indexNoPriorityM: number
  public indexNoPriorityL: number


  public indexNoSeverityH: number
  public indexNoSeverityM: number
  public indexNoSeverityL: number

  public environment: number

  public indexissue: number = 0;

  // Issue Detail
  Detailtile: string = '';
  DetailDescription: string = '';
  DetailStatus: string = '';
  DetailDateRaised: string = '';
  DetailDueDate: string = '';
  DetailRaiseBy: string = '';
  DetailActionOwner: string = '';
  DetailPriority: string = '';
  DetailSeverity: string = '';
  Detailtragetdate: string = '';
  DetailissueType: string = '';
  Detailhistoryprogress: string = '';
  Detailhtmldetailfile: string = '';

  //Base line document
  baselineFilesToUpload: File[];
  baselinePathFile: string = '';
  IsClearList: string = '';

  expiration_date: Date;
  todayPassword: Date;
  expireValue: string;
  todayValue: string;

  // Export Excel
  displayedColumns: string[] = ["position", "name", "weight", "symbol"];
  matColumns: string[] = ["name", "symbol"];
  dataSourceExcel = ELEMENT_DATA;
  reverseDataSource = [...ELEMENT_DATA].reverse();

  IssueDocumentListPromise: Promise<IssueDocumentInfo[]>
  IssueDocumentList: IssueDocumentInfo[] = []
  IssueDocumentListPromisereturn: Promise<IssueDocumentInfo[]>[]


  //empselect
  employeeselectrun: boolean = false;
  employeeselectreturnto: string;
  selectedemp: EmpInfo;

  _EmpRole: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private formBuilder: FormBuilder, private TokenService: TokenService, private activatedRoute: ActivatedRoute,) {
    this.baseurl = environment.base_api;
     monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    //GlobalService.CheckPagingAccessRights();
    this.nowFormatted = formatDate(this.now, 'dd/MM/yyyy', 'en-US');
  }

  async ngOnInit() {

    this.IssueForm = this.formBuilder.group({
      txtTitle: [null, Validators.required],
      txtDescription: [null],
      ddlIssueStatus: [null],
      txtDateraise: [null],
      txtDuedate: [null],
      ddlRaiseby: [null],
      ddlIssueOwner: [null],
      ddlPriority: [null],
      ddlSeverity: [null],
      txtTargetCompletionDate: [null],
      ddlIssueType: [null],
      txtCurrentProgress: [null],
      txtResolutionPlan: [null]
      //hidIssueId: [null]
    },
      {
        // Used custom form validator 
        validator: [this.checkdate("txtDateraise", "txtDuedate"), this.checkdate("txtDateraise", "txtTargetCompletionDate")]
      }
    );

    this.Clearinput();
    this.environment = environment.PageSize;
    this.LoadIssueDocument(this.IssueId);
    this.IsClearList = "false";

    Chart.defaults.global.legend.display = false;
    Chart.defaults.global.defaultFontSize = 18;

    this.panelOpenState = false;
    this.panelOpenStateIssue = false;

    this.resultUploadfile = { type: null };
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;//this.GetParam('ProjectCode').toString();
    this._ParamProjectName = this.activatedRoute.snapshot.params.ProjectName;//this.GetParam('ProjectName').toString().replace(/%20/g, " ");
    this.ProjectNameText = this.activatedRoute.snapshot.params.ProjectName;//this.GetParam('ProjectName').toString();

    document.getElementById("InsertSectionIssue").style.display = "none"
    document.getElementById("SearchPanel").style.display = "none"


    this.currentPageNumber = 1;
    this.currentPageNumberPriorityH = 1;
    this.currentPageNumberPriorityM = 1;
    this.currentPageNumberPriorityL = 1;

    this.currentPageNumberSeverityH = 1;
    this.currentPageNumberSeverityM = 1;
    this.currentPageNumberSeverityL = 1;
    this.indexNoPriorityH = 1;
    this.indexNoPriorityM = 1;
    this.indexNoPriorityL = 1;

    this.indexNoSeverityH = 0;
    this.indexNoSeverityM = 0;
    this.indexNoSeverityL = 0;

    this.totalPagesPriorityH = 1;
    this.totalPagesPriorityM = 1;
    this.totalPagesPriorityL = 1;


    this.LoadIssueAll();
    this.LoadIssue();
    this.LoadIssuePriorityDetailHighList();
    this.LoadIssuePriorityDetailMediumList();
    this.LoadIssuePriorityDetailLowList();

    this.LoadIssueSeverityDetailHighList();
    this.LoadIssueSeverityDetailMediumList();
    this.LoadIssueSeverityDetailLowList();

    this.loadDDLPriority();
    this.loadDDLSeverity();
    this.loadDDLStatus();
    this.loadDDLIssueType();
    this.loadDDLProject();
    this.loadDDLRaiseBy();
    this.loadDDLIssueOwner();

    this.txtTargetCompletionDate = null
    this.txtCurrentProgress = null
    this.lblCurrentProgress = null
    this.txtResolutionPlan = null
    this.txtDescription = null
    this.ddlSearchRaiseBy = null
    this.ddlSearchIssueStatus = null
    this.ddlSearchPriority = null
    this.ddlSearchSeverity = null
    this.ddlSearchIssueOwner = null
    this.ddlSearchIssueType = null
    this.ddlIssueStatus = null
    this.ddlIssueType = null
    this.ddlSearchIssueType = null
    this.txtDateraise = null
    this.txtDuedate = null
    this.ddlRaiseby = null
    this.ddlIssueOwner = null
    this.ddlPriority = null
    this.ddlSeverity = null
    this.txtTitle = null
    this.hidIssueId = null

    this._EmpRole = localStorage.getItem("EmpRoleCode");
/*    console.log(this._EmpRole,'This._EmpRole')*/
  }
  ///////////////////////////////////////Events////////////////////////////////////////////
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.IssueForm.patchValue({
      //RoleCode: null,
      //RoleName: null,
      ddlIssueStatus: "1",
      //CreateBy: localStorage.getItem("EmpCode") + " - " + localStorage.getItem("EmpName_TH"),

    });
  }

  btnClick_showIssueList() {
    //this.LoadIssueAll();
    //this.LoadIssuePriorityDetailHighList();
    //this.LoadIssuePriorityDetailMediumList();
    //this.LoadIssuePriorityDetailLowList();
    //this.LoadIssueSeverityDetailHighList();
    //this.LoadIssueSeverityDetailMediumList();
    //this.LoadIssueSeverityDetailLowList();
    //this.LoadIssue();

    this.currentPageNumber = 1
    this.currentPageNumberPriorityH = 1;
    this.currentPageNumberPriorityM = 1;
    this.currentPageNumberPriorityL = 1;

    this.currentPageNumberSeverityH = 1;
    this.currentPageNumberSeverityM = 1;
    this.currentPageNumberSeverityL = 1;
    this.indexNoPriorityH = 0;
    this.indexNoPriorityM = 0;
    this.indexNoPriorityL = 0;

    this.indexNoSeverityH = 0;
    this.indexNoSeverityM = 0;
    this.indexNoSeverityL = 0;

    this.totalPagesPriorityH = 1;
    this.totalPagesPriorityM = 1;
    this.totalPagesPriorityL = 1;

    this.LoadIssueAll();
    this.LoadIssuePriorityDetailHighList();
    this.LoadIssuePriorityDetailMediumList();
    this.LoadIssuePriorityDetailLowList();
    this.LoadIssueSeverityDetailHighList();
    this.LoadIssueSeverityDetailMediumList();
    this.LoadIssueSeverityDetailLowList();
    this.LoadIssue();
  }
  btnClick_onSearchPanel() {
    document.getElementById("SearchPanel").style.display = "block"

  }

  btnClick_onInsertIssue() {
    this.todayPassword = new Date();
    this.expiration_date = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);

    const ExpireValue = formatDate(this.expiration_date, 'yyyy-MM-dd', 'en-US');
    const TodayValue = formatDate(this.todayPassword, 'yyyy-MM-dd', 'en-US');

    this.expireValue = ExpireValue;
    this.todayValue = TodayValue;

    document.getElementById("InsertSectionIssue").style.display = "block"
    this.IssueForm.reset();
    this.txtTargetCompletionDate = null
    this.txtCurrentProgress = null
    this.lblCurrentProgress = null
    this.txtResolutionPlan = null
    this.txtDescription = null

    this.ddlIssueStatus = "1"
    this.txtDateraise = this.todayValue
    this.txtDuedate = this.expireValue
    this.ddlRaiseby = null
    this.ddlIssueOwner = null
    this.ddlIssueType = "3"
    this.ddlPriority = "1"
    this.ddlSeverity = "1"
    this.txtTitle = null
    this.hidIssueId = null
    this.baselineFilesToUpload = null
    this.baselinePathFile = null
    this.IsClearList = null


    

    this.isOnUpdate = false
    $('#displayfileupload').hide();
    $('#filer_input1').show();
    $('#filer_input1').val('')

  }

  btnClick_onUpdateIssue(id) {
    this.IssueForm.reset();
    document.getElementById("InsertSectionIssue").style.display = "block"
    $('#filer_input1').val('');
    this.isOnUpdate = true

    let index = this.issueList.findIndex(x => x.IssueId == id);

    this.ddlIssueStatus = this.issueList[index].IssueStatusCode != null ? this.issueList[index].IssueStatusCode : null;
    this.txtDateraise = this.formatDate(this.issueList[index].DateRaise);
    this.txtDuedate = this.formatDate(this.issueList[index].DueDate);
    this.ddlRaiseby = this.issueList[index].RaiseByCode != null ? this.issueList[index].RaiseByCode : null;
    this.ddlIssueOwner = this.issueList[index].IssueOwnerCode != null ? this.issueList[index].IssueOwnerCode : null;
    this.ddlPriority = this.issueList[index].PriorityCode != null ? this.issueList[index].PriorityCode : null;
    this.ddlIssueType = this.issueList[index].IssueTypeCode != null ? this.issueList[index].IssueTypeCode : null;
    this.ddlSeverity = this.issueList[index].SeverityCode != null ? this.issueList[index].SeverityCode : null;
    this.txtTitle = this.issueList[index].Title;
    this.txtTargetCompletionDate = this.formatDate(this.issueList[index].TargetCompletionDate);

    this.lblCurrentProgress = this.issueList[index].CurrentProgress;
    this.txtCurrentProgress = null;

    this.txtResolutionPlan = this.issueList[index].ResolutionPlan
    this.txtDescription = this.issueList[index].Description
    this.displayfilename = this.issueList[index].FileName != null && this.issueList[index].FileName != '' && this.issueList[index].FileName != "undefined" ? this.issueList[index].FileName : null
    this.LoadIssueDocument(id);
    if (this.displayfilename != null && this.displayfilename != '') {
      this.linkdowloadfile = this.baseurl + "issue/downloadfileissue/" + id;
      $('#displayfileupload').show();
      $('#filer_input1').hide();
    } else {
      $('#displayfileupload').hide();
      $('#filer_input1').show();

    }
    this.hidIssueId = this.issueList[index].IssueId

    console.log("Open Issue")
    console.log(id)
    console.log(index)
    console.log(this.issueList[index])
  }


  btnClick_onUpdateIssueDetail(id) {
    $('#ModalDetailIssue').modal('hide'); // hide modal
    this.flagexpandIssue = true; // set issue detail Expanded
    // set focus layout edit
    $('mat-sidenav-content').animate({ scrollTop: $("#InsertSectionIssue").offset().top }, 500);
    this.IssueForm.reset();
    document.getElementById("InsertSectionIssue").style.display = "block"
    $('#filer_input1').val('');
    this.isOnUpdate = true

    let index = this.issueListAll.findIndex(x => x.IssueId == id);

    this.ddlIssueStatus = this.issueListAll[index].IssueStatusCode != null ? this.issueListAll[index].IssueStatusCode : null
    this.txtDateraise = this.formatDate(this.issueListAll[index].DateRaise)
    this.txtDuedate = this.formatDate(this.issueListAll[index].DueDate)
    this.ddlRaiseby = this.issueListAll[index].RaiseByCode != null ? this.issueListAll[index].RaiseByCode : null
    this.ddlIssueOwner = this.issueListAll[index].IssueOwnerCode != null ? this.issueListAll[index].IssueOwnerCode : null
    this.ddlPriority = this.issueListAll[index].PriorityCode != null ? this.issueListAll[index].PriorityCode : null
    this.ddlIssueType = this.issueListAll[index].IssueTypeCode != null ? this.issueListAll[index].IssueTypeCode : null
    this.ddlSeverity = this.issueListAll[index].SeverityCode != null ? this.issueListAll[index].SeverityCode : null
    this.txtTitle = this.issueListAll[index].Title
    this.txtTargetCompletionDate = this.formatDate(this.issueListAll[index].TargetCompletionDate)

    this.lblCurrentProgress = this.issueListAll[index].CurrentProgress
    this.txtCurrentProgress = null

    this.txtResolutionPlan = this.issueListAll[index].ResolutionPlan
    this.txtDescription = this.issueListAll[index].Description
    this.displayfilename = this.issueListAll[index].FileName != null && this.issueListAll[index].FileName != '' && this.issueListAll[index].FileName != "undefined" ? this.issueListAll[index].FileName : null

    if (this.displayfilename != null && this.displayfilename != '') {
      this.linkdowloadfile = "/issue/downloadfileissue/" + id;
      $('#displayfileupload').show();
      $('#filer_input1').hide();
    } else {
      $('#displayfileupload').hide();
      $('#filer_input1').show();

    }
    this.hidIssueId = this.issueListAll[index].IssueId

  }

  async btnClick_deleteIssue(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{EmpId: " + id + "}";

      if (confirm("Are you sure you want to delete this Issue?")) {
        this.isSubmitted = this.httpClient.post<EmpInfo[]>(this.baseurl + "Issue/DeleteIssue", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()
              this.LoadIssue()
            }
          )
      }
    }
  }

  async btnClick_submitInsertIssue() {
    //this.OnCreating('y');
    if (this.IssueForm.valid) {
      //this.loading(true, 'Saving ...');

      await this.uploadfile();

      var pathfile = "";
      var filename = "";
      if (this.resultUploadfile.type === HttpEventType.Response) {
       

        if (this.resultUploadfile.body.list.length > 0) {
          pathfile = this.resultUploadfile.body.list[0].dbPath.replace(String.fromCharCode(92), "/");
          filename = this.resultUploadfile.body.list[0].fileName;
        }

      }

      document.getElementById("InsertSectionIssue").style.display = "block"
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        if (this.txtCurrentProgress != undefined && this.txtCurrentProgress != null && this.txtCurrentProgress != '') {
          this.txtCurrentProgress = this.txtCurrentProgress.replace(/\r?\n/g, '<br />');

          this.txtCurrentProgress = this.txtCurrentProgress.split('"').join('&#34');

          this.txtCurrentProgress = this.txtCurrentProgress.split('\'').join('&#39');

          this.txtCurrentProgress = "<div class='history-issue'>" + "<b>" + this.nowFormatted + " </b>" + ": <br>" + this.txtCurrentProgress + "</div>";
        }

        var objectjson = {};
        objectjson['IssueStatusCode'] = this.checkUndefinedString(this.ddlIssueStatus);
        objectjson['DateRaise'] = this.checkUndefinedDate(this.txtDateraise);
        objectjson['DueDate'] = this.checkUndefinedDate(this.txtDuedate);
        objectjson['RaiseByCode'] = this.checkUndefinedString(this.ddlRaiseby);
        objectjson['IssueOwnerCode'] = this.checkUndefinedString(this.ddlIssueOwner);
        objectjson['IssueTypeCode'] = this.checkUndefinedString(this.ddlIssueType);
        objectjson['Title'] = this.checkUndefinedString(this.txtTitle);
        objectjson['PriorityCode'] = this.checkUndefinedString(this.ddlPriority);
        objectjson['SeverityCode'] = this.checkUndefinedString(this.ddlSeverity);
        objectjson['ProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);
        objectjson['CurrentProgressLasted'] = this.checkUndefinedString(this.txtCurrentProgress);
        objectjson['CurrentProgress'] = this.checkUndefinedString(this.txtCurrentProgress);
        objectjson['Description'] = this.checkUndefinedString(this.txtDescription);
        objectjson['ResolutionPlan'] = this.checkUndefinedString(this.txtResolutionPlan);
        objectjson['TargetCompletionDate'] = this.checkUndefinedDate(this.txtTargetCompletionDate);
        //objectjson['FileName'] = filename;
        //objectjson['PathFile'] = pathfile;
        objectjson['FlagDelete'] = "N";


        let strjson = JSON.stringify(objectjson);
        
        this.httpClient.post<number>(this.baseurl + "Issue/InsertIssue", strjson, httpOptions).toPromise()

          .then(async result => {
            
            console.log("issueid: " + result);
            //console.log("Insert = " + )
            if (!!this.baselineFilesToUpload) {
              var isUploadSuccess = await this.UploadEventFilesToServer(this.baselineFilesToUpload);
              if (isUploadSuccess) {
                for (const val of this.baselineFilesToUpload) {
                  /*this.LoadIssue(this.IssueId);*/
                  await this.InsertIssueDocument(val.name, this.baselinePathFile + "\\" + val.name, result)
                  console.log("VAL: ", this.IssueId);
                }
                //this.OnCreating('n');
                this.IsClearList = "true";
                //await this.LoadEvent();
                this.clearInsertSection()
                this.LoadIssueAll()
                this.LoadIssuePriorityDetailHighList();
                this.LoadIssuePriorityDetailMediumList();
                this.LoadIssuePriorityDetailLowList();

                this.LoadIssueSeverityDetailHighList();
                this.LoadIssueSeverityDetailMediumList();
                this.LoadIssueSeverityDetailLowList();
                this.LoadIssue()
                $('#ModalCreateComplate').modal();
                $('#modalEventController').modal('hide')

                this.baselineFilesToUpload = []
                this.baselinePathFile = '';
              } else {
                //this.OnCreating('y');
              }

            } else {
              this.OnCreating('n');
              this.loading(false);

              this.titlemodal = 'Thank you for your inquiry.';
              this.detailmodal = 'Our support team will get back to you shortly.';
              $('#ModalComplate').modal();

              this.clearInsertSection()
              this.LoadIssueAll()
              this.LoadIssuePriorityDetailHighList();
              this.LoadIssuePriorityDetailMediumList();
              this.LoadIssuePriorityDetailLowList();

              this.LoadIssueSeverityDetailHighList();
              this.LoadIssueSeverityDetailMediumList();
              this.LoadIssueSeverityDetailLowList();
              this.LoadIssue()
            }

          }
          )
      }
    } else {
      this.markFormGroupTouched(this.IssueForm as FormGroup);

    }
  }

  async btnClick_submitUpdateIssue(id) {
    if (this.IssueForm.valid) {
      //this.loading(true, 'Saving ...');

      await this.uploadfile();

      var pathfile = "";
      var filename = "";
      if (this.resultUploadfile.type === HttpEventType.Response) {
        pathfile = this.resultUploadfile.body.list[0].dbPath.replace(String.fromCharCode(92), "/");
        filename = this.resultUploadfile.body.list[0].fileName;
        
      }
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        document.getElementById("InsertSectionIssue").style.display = "block"
        id = this.hidIssueId
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let strreplace = "<br><font color=red>";
        if (this.txtCurrentProgress != undefined && this.txtCurrentProgress != null && this.txtCurrentProgress != '') {

          this.txtCurrentProgress = this.txtCurrentProgress.replace(/\r?\n/g, '<br />');

          this.txtCurrentProgress = this.txtCurrentProgress.split('"').join('&#34');

          this.txtCurrentProgress = this.txtCurrentProgress.split('\'').join('&#39');

          this.lblCurrentProgress = "<div class='history-issue'>" + "<b>" + this.nowFormatted + "</b>: <br>" + this.txtCurrentProgress + "<br>" + "</div>" + this.lblCurrentProgress;

        } else {

          this.txtCurrentProgress = "";
        }


        var objectjson = {};
        objectjson['IssueStatusCode'] = this.checkUndefinedString(this.ddlIssueStatus);
        objectjson['DateRaise'] = this.checkUndefinedDate(this.txtDateraise);
        objectjson['DueDate'] = this.checkUndefinedDate(this.txtDuedate);
        objectjson['RaiseByCode'] = this.checkUndefinedString(this.ddlRaiseby);
        objectjson['IssueOwnerCode'] = this.checkUndefinedString(this.ddlIssueOwner);
        objectjson['IssueTypeCode'] = this.checkUndefinedString(this.ddlIssueType);
        objectjson['Title'] = this.checkUndefinedString(this.txtTitle);
        objectjson['PriorityCode'] = this.checkUndefinedString(this.ddlPriority);
        objectjson['SeverityCode'] = this.checkUndefinedString(this.ddlSeverity);
        objectjson['ProjectCode'] = this.checkUndefinedString(this._ParamProjectCode);
        objectjson['CurrentProgressLasted'] = this.checkUndefinedString(this.txtCurrentProgress);
        objectjson['CurrentProgress'] = this.checkUndefinedString(this.lblCurrentProgress);
        objectjson['Description'] = this.checkUndefinedString(this.txtDescription);
        objectjson['ResolutionPlan'] = this.checkUndefinedString(this.txtResolutionPlan);
        objectjson['TargetCompletionDate'] = this.checkUndefinedDate(this.txtTargetCompletionDate);
        objectjson['IssueId'] = id;
        //objectjson['FileName'] = filename;
        //objectjson['PathFile'] = pathfile;


        let strjson = JSON.stringify(objectjson);
        console.log("strjson: ", strjson);
        //return strjson;

        this.isSubmitted = this.httpClient.post<IssueInfo[]>(this.baseurl + "Issue/UpdateIssue", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")

            this.loading(false);

            this.titlemodal = 'Update Issue fail.';
            this.detailmodal = 'Your Issue was Update fail.';
            $('#ModalError').modal();
            
            
          },
            
            async () => {
              console.log("Update = " + this.isSubmitted)

              if (!!this.baselineFilesToUpload) {

                var isUploadSuccess = await this.UploadEventFilesToServer(this.baselineFilesToUpload);
                if (isUploadSuccess) {
                  for (const val of this.baselineFilesToUpload) {
                    await this.InsertIssueDocument(val.name, this.baselinePathFile + "\\" + val.name, this.hidIssueId)
                  }

                  //this.OnEditing('n');
                  this.IsClearList = "true";
                  //await this.LoadEvent();
                  this.clearInsertSection()
                  this.LoadIssueAll()
                  this.LoadIssuePriorityDetailHighList();
                  this.LoadIssuePriorityDetailMediumList();
                  this.LoadIssuePriorityDetailLowList();

                  this.LoadIssueSeverityDetailHighList();
                  this.LoadIssueSeverityDetailMediumList();
                  this.LoadIssueSeverityDetailLowList();
                  this.LoadIssue()
                  $('#ModalUpdateComplate').modal();
                  $('#modalEventController').modal('hide')

                  this.baselineFilesToUpload = []
                  this.baselinePathFile = '';
                } else {
                  //this.OnEditing('y');
                }

              } else {
                //this.OnEditing('n');
                //await this.LoadEvent();
                //$('#ModalUpdateComplate').modal();
                //$('#modalEventController').modal('hide')
                this.loading(false);

                this.titlemodal = 'Update Issue done.';
                this.detailmodal = 'Your Issue was updated successfully.';
                $('#ModalComplate').modal();

                this.clearInsertSection()
                this.LoadIssueAll()
                this.LoadIssuePriorityDetailHighList();
                this.LoadIssuePriorityDetailMediumList();
                this.LoadIssuePriorityDetailLowList();

                this.LoadIssueSeverityDetailHighList();
                this.LoadIssueSeverityDetailMediumList();
                this.LoadIssueSeverityDetailLowList();
                this.LoadIssue()
              }
            }
          )
      }
    } else {
      this.markFormGroupTouched(this.IssueForm as FormGroup);

    }
  }

  btnClick_previous() {
    if (this.currentPageNumber == 1) {
    } else {
      this.currentPageNumber -= 1
      this.LoadIssue();
    }
  }

  btnClick_next() {
    if (this.currentPageNumber == this.totalPages) {
    } else {
      this.currentPageNumber += 1
      this.LoadIssue();
    }
  }

  btnClick_first() {
    if (this.currentPageNumber == 1) {
    } else {
      this.currentPageNumber = 1
      this.LoadIssue();
    }
  }

  btnClick_last() {
    if (this.currentPageNumber == this.totalPages) {
    } else {
      this.currentPageNumber = this.totalPages
      this.LoadIssue();
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  async btnClick_onSendMail() {
    {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let strjson = "{" +


          "\"ToName\" : \"Sarawut Srikree\"," +
          "\"MailTo\": \"sarawut@double-p.co.th\"," +
          "\"TransactionNo\": \"SO100029\"," +
          "\"Password\": \"s4635735\"," +
          "\"MailTypeCode\": \"UPDATEISSUE\"" +
          "}";

        this.isSubmitted = this.httpClient.post<IssueInfo[]>(this.baseurl + "Mail/SendMail", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              alert("Send Mail Successfully");
              this.clearInsertSection()
              this.LoadIssue()
            }
          )




      }
    }
  }

  async btnClick_onDeleteIssue() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('Id' + i);

      if (isChecked) {

        await this.btnClick_deleteIssue(parseInt(element2.value));
      }
    }
    this.LoadIssue();
  }

  ///////////////////////////////////////Functions/////////////////////////////////////////
  GetDateNow(): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "July", "August", "Sep", "Oct", "Nov", "Dec"
    ];

    const d = new Date();

    return d.getDate().toString() + "-" + monthNames[d.getMonth()].toString() + "-" + d.getFullYear().toString();

  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  LoadIssue(traget = null) {

    if (traget != null) {
      this.LoadissueUpdatePagination(traget);
    }
    this.LoadIssueList()
      .then(
        data => {
          this.issueList = data

          this.dataSource.data = data

          this.hidcouchk = this.issueList.length.toString();

        }
      )
      .then(() => {
        this.CountIssueList()
      })
  }

  LoadIssueDocumentList(IssueId, auth_token): Observable<IssueDocumentInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    //IssueId = this.hidIssueId;
    //let index = this.issueListAll.findIndex(x => x.IssueId == IssueId);
    //this.hidIssueId = this.issueListAll[index].IssueId
    var objectjson = {};
    objectjson['IssueId'] = IssueId;
    objectjson['FlagDelete'] = "N";

    let strjson = JSON.stringify(objectjson);
    return this.httpClient
      .post<IssueDocumentInfo[]>(this.baseurl + "IssueDocument/GetIssueDocument",
        strjson, httpOptions)

  }

  async InsertIssueDocument(Filename, pathfile, issueid) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      document.getElementById("InsertSectionIssue").style.display = "block"
      //issueid = this.hidIssueId;

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      
      objectjson['IssueId'] = issueid;
      objectjson['IssueDocumentFileName'] = Filename;
      objectjson['IssueDocumentPathFile'] = pathfile;
      objectjson['FlagDelete'] = "N";
      objectjson['CreateBy'] = localStorage.getItem("EmpCode");
      
      let strjson = JSON.stringify(objectjson);

      this.isSubmitted = this.httpClient.post<IssueDocumentInfo[]>(this.baseurl + "IssueDocument/InsertIssueDocument", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.LoadIssueDocument(this.IssueId);
          }
        )
    }
  }

  async LoadIssueDocument(IssueId) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadIssueDocumentList(IssueId, auth_token)
        .subscribe({
          next: data => {
            this.IssueDocumentList = data;
          },
          error: error => {
            console.error('There was an error!', error);
          }
        });
    }
  }


  LoadIssueAll() {
    this.LoadIssueList(true)
      .then(
        data => {

          console.log('Total issue')
          console.log(data)

          this.issueListAll = data;
          this.IssueSummaryTotal  = data.filter(x => x.IssueStatusName != "Closed").length;
          this.summaryInfo.sumPriorityL = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Low").length;
          this.summaryInfo.sumPriorityM = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium").length;
          this.summaryInfo.sumPriorityH = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High").length;
          this.summaryInfo.sumPriorityNotSet = data.filter(x => x.IssueStatusName != "Closed" && (x.PriorityName == "" || x.PriorityName == null) ).length;


          this.summaryInfo.sumSeverityL = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor").length;
          this.summaryInfo.sumSeverityM = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major").length;
          this.summaryInfo.sumSeverityH = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical").length;
          this.summaryInfo.sumSeverityNotSet = data.filter(x => x.IssueStatusName != "Closed" && (x.SeverityName == "" || x.SeverityName == null)).length;


          this.summaryInfo.sumStatusOpen = data.filter(x => x.IssueStatusName == "Open").length;
          this.summaryInfo.sumStatusInprogress = data.filter(x => x.IssueStatusName == "In Progress").length;
          this.summaryInfo.sumStatusClosed = data.filter(x => x.IssueStatusName == "Closed").length;
          this.summaryInfo.sumStatusNew = data.filter(x => x.IssueStatusName == "New").length;
          this.summaryInfo.sumStatusHold = data.filter(x => x.IssueStatusName == "Hold").length;


          this.summaryInfo.PriorityLList = data.filter(x => x.IssueStatusName != "Closed" &&  x.PriorityName == "Low");
          this.summaryInfo.PriorityMList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "Medium");
          this.summaryInfo.PriorityHList = data.filter(x => x.IssueStatusName != "Closed" && x.PriorityName == "High");

          this.summaryInfo.SeverityLList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Minor");
          this.summaryInfo.SeverityMList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Major");
          this.summaryInfo.SeverityHList = data.filter(x => x.IssueStatusName != "Closed" && x.SeverityName == "Critical");
          
          this.summaryInfo.sumPriorityLList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityLList);
          this.summaryInfo.sumPriorityMList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityMList);
          this.summaryInfo.sumPriorityHList = this.GroupAndSumStatusIssue(this.summaryInfo.PriorityHList);

          this.summaryInfo.sumSeverityLList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityLList);
          this.summaryInfo.sumSeverityMList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityMList);
          this.summaryInfo.sumSeverityHList = this.GroupAndSumStatusIssue(this.summaryInfo.SeverityHList);

          this.pieChartLabels = ['Open', 'In Progress', 'Hold', 'Closed']
          this.pieChartData = [this.summaryInfo.sumStatusOpen, this.summaryInfo.sumStatusInprogress, this.summaryInfo.sumStatusHold, this.summaryInfo.sumStatusClosed];
          this.pieChartColors[0].backgroundColor = ['#6ae7d8', '#6a8fef', '#e8a362', '#5f5e5e'];
        }
      )
  }

  LoadIssuePriorityDetailHighList() {
    this.LoadIssueListDetail(this.currentPageNumberPriorityH, "3")
      .then(
        data => {
          this.summaryInfo.PriorityDetailHList = data;

        }
      )

    this.CountIssueListDetail(this.currentPageNumberPriorityH, "3")
      .then(
        data => {
          this.totalIssuePriorityH = data;
          if(this.totalIssuePriorityH == 1) this.currentPageNumberPriorityH = 1;
          this.totalPagesPriorityH = Math.ceil(this.totalIssuePriorityH / environment.PageSize)

        }
      )
  }

  LoadIssuePriorityDetailMediumList() {
    this.LoadIssueListDetail(this.currentPageNumberPriorityM, "2")
      .then(
        data => {
          this.summaryInfo.PriorityDetailMList = data;

        }
      )

    this.CountIssueListDetail(this.currentPageNumberPriorityM, "2")
      .then(
        data => {
          this.totalIssuePriorityM = data;
          if(this.totalIssuePriorityM == 1) this.currentPageNumberPriorityM = 1;
          this.totalPagesPriorityM = Math.ceil(this.totalIssuePriorityM / environment.PageSize)

        }
      )
  }

  LoadIssuePriorityDetailLowList() {
    this.LoadIssueListDetail(this.currentPageNumberPriorityL,"1")
      .then(
        data => {
          this.summaryInfo.PriorityDetailLList = data;

        }
    )

    this.CountIssueListDetail(this.currentPageNumberPriorityL, "1")
      .then(
        data => {
          this.totalIssuePriorityL = data;
          if(this.totalIssuePriorityL == 1) this.currentPageNumberPriorityL = 1;
          this.totalPagesPriorityL = Math.ceil(this.totalIssuePriorityL / environment.PageSize)

        }
      )
  }


  LoadIssueSeverityDetailHighList() {
    this.LoadIssueListDetail(this.currentPageNumberSeverityH, "","3")
      .then(
        data => {
          this.summaryInfo.SeverityDetailHList = data;

        }
      )

    this.CountIssueListDetail(this.currentPageNumberSeverityH, "", "3")
      .then(
        data => {
          this.totalIssueSeverityH = data;
          if(this.totalIssueSeverityH == 1) this.currentPageNumberSeverityH = 1;
          this.totalPagesSeverityH = Math.ceil(this.totalIssueSeverityH / environment.PageSize)

        }
      )
  }

  LoadIssueSeverityDetailMediumList() {
    this.LoadIssueListDetail(this.currentPageNumberSeverityM, "", "2")
      .then(
        data => {
          this.summaryInfo.SeverityDetailMList = data;

        }
      )

    this.CountIssueListDetail(this.currentPageNumberSeverityM, "", "2")
      .then(
        data => {
          this.totalIssueSeverityM = data;
          if(this.totalIssueSeverityM == 1) this.currentPageNumberSeverityM = 1;
          this.totalPagesSeverityM = Math.ceil(this.totalIssueSeverityM / environment.PageSize)

        }
      )
  }

  LoadIssueSeverityDetailLowList() {
    this.LoadIssueListDetail(this.currentPageNumberSeverityL, "", "1")
      .then(
        data => {
          this.summaryInfo.SeverityDetailLList = data;

        }
      )

    this.CountIssueListDetail(this.currentPageNumberSeverityL, "", "1")
      .then(
        data => {
          this.totalIssueSeverityL = data;
          if(this.totalIssueSeverityL == 1) this.currentPageNumberSeverityL = 1;
          this.totalPagesSeverityL = Math.ceil(this.totalIssueSeverityL / environment.PageSize)

        }
      )
  }


  async LoadIssueList(Getall: boolean = false): Promise<IssueInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      // Update variable for pagination from pagination control
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      objectjson['PriorityCode'] = this.ddlSearchPriority;
      objectjson['IssueStatusCode'] = this.ddlSearchIssueStatus;
      objectjson['IssueOwnerCode'] = this.ddlSearchIssueOwner;
      objectjson['IssueTypeCode'] = this.ddlSearchIssueType;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";

      if (Getall == true) {
        objectjson['rowFetch'] = 0;
        objectjson['rowOFFSet'] = 0;

      }

      let strjson = JSON.stringify(objectjson);

      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  async LoadIssueListDetail(currentPageNumber, PriorityCode = '', SeverityCode = ''): Promise<IssueInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};

      if (PriorityCode != '') {
        objectjson['PriorityCodeDetail'] = PriorityCode;
      }
      if (SeverityCode != '') {
        objectjson['SeverityCodeDetail'] = SeverityCode;
      }

      objectjson['PriorityCode'] = this.ddlSearchPriority;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['exceptIssueStatusCode'] = "3";
      objectjson['IssueStatusCode'] = this.ddlSearchIssueStatus;
      objectjson['IssueOwnerCode'] = this.ddlSearchIssueOwner;
      objectjson['IssueTypeCode'] = this.ddlSearchIssueType;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['ProjectCode'] = this._ParamProjectCode;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      objectjson['FlagDelete'] = "N";



      let strjson = JSON.stringify(objectjson);

      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  async CountIssueListDetail(currentPageNumber, PriorityCode = '', SeverityCode = ''): Promise<IssueInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      if (PriorityCode != '') {
        objectjson['PriorityCodeDetail'] = PriorityCode;
      }
      if (SeverityCode != '') {
        objectjson['SeverityCodeDetail'] = SeverityCode;
      }
      objectjson['PriorityCode'] = this.ddlSearchPriority;
      objectjson['SeverityCode'] = this.ddlSearchSeverity;
      objectjson['exceptIssueStatusCode'] = "3";
      objectjson['IssueStatusCode'] = this.ddlSearchIssueStatus;
      objectjson['IssueOwnerCode'] = this.ddlSearchIssueOwner;
      objectjson['IssueTypeCode'] = this.ddlSearchIssueType;
      objectjson['RaiseByCode'] = this.ddlSearchRaiseBy;
      objectjson['ProjectCode'] = this._ParamProjectCode;


      objectjson['FlagDelete'] = "N";



      let strjson = JSON.stringify(objectjson);

      this.IssuePromise = this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetCountIssueCriteria",
          strjson, httpOptions)
        .toPromise()

      return this.IssuePromise;
    }
  }

  async CountIssueList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      var objectjson = {};
      objectjson["PriorityCode"] = this.ddlSearchPriority;
      objectjson["IssueStatusCode"] = this.ddlSearchIssueStatus;
      objectjson["IssueOwnerCode"] = this.ddlSearchIssueOwner;
      objectjson["IssueTypeCode"] = this.ddlSearchIssueType;
      objectjson["SeverityCode"] = this.ddlSearchSeverity;
      objectjson["RaiseByCode"] = this.ddlSearchRaiseBy;
      objectjson["ProjectCode"] = this._ParamProjectCode;
      objectjson["FlagDelete"] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<IssueInfo[]>(this.baseurl + "Issue/GetCountIssueCriteria",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.IssueTotal = data
          if(this.IssueTotal == 0) this.currentPageNumber = 0;
        })
        .then(() => {
          this.totalPages = Math.ceil(this.IssueTotal / environment.PageSize)
        });
    }
  }

  async loadDDLSeverity() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"ISSUESEVERITY\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SeverityList = data
        });
    }
  }

  async loadDDLPriority() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"ISSUEPriority\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.PriorityList = data
        })
    }
  }

  async loadDDLIssueType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"ISSUETYPE\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.IssueTypeList = data
        });
    }
  }

  async loadDDLStatus() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"LookupType\":\"ISSUESTATUS\" }";

      this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.IssueStatusList = data
        });
    }
  }

  async loadDDLProject() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjson = "{\"ProjectCode\":\"\" }";

      this.httpClient.post<ProjectInfo[]>(this.baseurl + "Project/GetProjectCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectList = data
        });
    }
  }

  async loadDDLIssueOwner() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      /*let strjson = "{\"EmpCode\":\"\" }";*/
      var objectjson = {};
      objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
        .toPromise().then((data) => {
          this.IssueOwnerList = data
          console.log(this.IssueOwnerList);
        });
    }
  }

  async loadDDLRaiseBy() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      //let strjson = "{\"EmpCode\":\"\" }";
      var objectjson = {};
      objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ContactlistInfo[]>(this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
        .toPromise().then((data) => {
          this.RaiseByList = data
        });
    }
  }
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  clearInsertSection() {
    this.txtTargetCompletionDate = null
    this.txtCurrentProgress = null
    this.lblCurrentProgress = null
    this.txtResolutionPlan = null
    this.txtDescription = null

    this.ddlIssueStatus = null
    this.txtDateraise = null
    this.txtDuedate = null
    this.ddlRaiseby = null
    this.ddlIssueOwner = null
    this.ddlPriority = null
    this.ddlSeverity = null
    this.txtTitle = null
    this.hidIssueId = null
    document.getElementById("InsertSectionIssue").style.display = "none"
  }

  clearSearchSection() {
    this.ddlSearchIssueStatus = null
    this.ddlSearchPriority = null
    this.ddlSearchIssueOwner = null
    this.ddlSearchSeverity = null
    this.ddlSearchRaiseBy = null

    this.currentPageNumberPriorityH = 1;
    this.currentPageNumberPriorityM = 1;
    this.currentPageNumberPriorityL = 1;

    this.currentPageNumberSeverityH = 1;
    this.currentPageNumberSeverityM = 1;
    this.currentPageNumberSeverityL = 1;
    this.indexNoPriorityH = 0;
    this.indexNoPriorityM = 0;
    this.indexNoPriorityL = 0;

    this.indexNoSeverityH = 0;
    this.indexNoSeverityM = 0;
    this.indexNoSeverityL = 0;
    this.currentPageNumber = 1

    this.LoadIssueAll();
    this.LoadIssuePriorityDetailHighList();
    this.LoadIssuePriorityDetailMediumList();
    this.LoadIssuePriorityDetailLowList();
    this.LoadIssueSeverityDetailHighList();
    this.LoadIssueSeverityDetailMediumList();
    this.LoadIssueSeverityDetailLowList();
    this.LoadIssue();
    //document.getElementById("SearchPanel").style.display = "none"
  }

  selectFileOnChange(traget) {
    if (traget.currentTarget.files.length) {
      var fileName = traget.currentTarget.files[0].name;
      this.filesToUpload = traget.currentTarget.files;
    }
  }

  async uploadfile() {
    if (this.filesToUpload != undefined) {
      if (this.filesToUpload.length > 0) {
        this.resultUploadfile = await this.GlobalService.uploadFile(this.filesToUpload, 'Resources\issueUploadFile')
      }
    }
  }

  btniconclose_onclick() {
    $('#displayfileupload').hide();
    $('#filer_input1').show();
  }

  btnClick_onShowAttach(id) {

    this.LoadIssueDocument(id)
    //this.DisplayFileUploadissue
    $('#ModalShowAttach').modal('show');
    //this.Clearinput();
    //this.isOnUpdate = false

  }

  DisplayFileUploadissue(filename: string, id: number) {
    var body = ""
    if (filename != null && filename != '' && filename != "undefined") {
      body += " <a href=\"" + this.baseurl + "IssueDocument/downloadfile/" + id + "\" target=\"_blank\">" + filename + "</a>"
    }
    return body;
  }

  chartClicked(traget) {
    
  }

  GroupAndSumStatusIssue(list) {
    var result = [];
    list.reduce(function (res, value) {
      if (!res[value.IssueOwnerCode]) {
        res[value.IssueOwnerCode] = { IssueOwnerName: value.IssueOwnerName, IssueOwnerCode: value.IssueOwnerCode, IssueOwnerNickName: value.IssueOwnerNickName, IssueAmount: 0, PriorityHigh: 0, PriorityMedium: 0, PriorityLow: 0, SeverityHigh: 0, SeverityMedium: 0, SeverityLow: 0 };
        result.push(res[value.IssueOwnerCode])
      }
      res[value.IssueOwnerCode].IssueAmount += 1;

      if (value.PriorityCode == "1") {
        res[value.IssueOwnerCode].PriorityLow += 1;
      }
      if (value.PriorityCode == "2") {
        res[value.IssueOwnerCode].PriorityMedium += 1;
      }
      if (value.PriorityCode == "3") {
        res[value.IssueOwnerCode].PriorityHigh += 1;
      }
      if (value.SeverityCode == "1") {
        res[value.IssueOwnerCode].SeverityLow += 1;
      }
      if (value.SeverityCode == "2") {
        res[value.IssueOwnerCode].SeverityMedium += 1;
      }
      if (value.SeverityCode == "3") {
        res[value.IssueOwnerCode].SeverityHigh += 1;
      }
      return res;
    }, {});

    return result;
  }


  btnClick_nextdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+currentPageNumber+` == this.`+totalPages+`) {
    } else {
      this.`+ currentPageNumber +` += 1;
      this.`+ indexName +` += this.environment;
      this.`+ functionName +`();
    }`;
    
    eval(command);
  }

  btnClick_previousdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+ currentPageNumber + ` == 1) {
    } else {
      this.`+ currentPageNumber + ` -= 1;
      this.`+ indexName + ` -= this.environment;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  btnClick_firstdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
    if (this.`+ currentPageNumber + ` == 1) {
    } else {
      this.`+ currentPageNumber + ` = 1;
      this.`+ indexName + ` = 0;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  btnClick_lastdynamic(currentPageNumber: string, totalPages: string, functionName: string, indexName: string) {
    var command = `
   if (this.`+ currentPageNumber + ` == this.` + totalPages + `) {
    } else {
      this.`+ currentPageNumber + ` = this.` + totalPages + `;
      var total = this.` + totalPages + `-1;
      this.`+ indexName + ` = this.environment * total;
      this.`+ functionName + `();
    }`;

    eval(command);
  }

  clearIssueDetaildynamic(List,totalpages,totalIssue,currentPage,indexNo) {
    var command = `
      this.`+ List + ` = [];
      this.`+ totalpages + ` = 0;
      this.`+ totalIssue + ` = 0;
      this.`+ currentPage + ` = 1;
      this.`+ indexNo + ` = 0;

    `;

    eval(command);

  }

  btnClick_DetailIssue(id) {

    let index = this.issueListAll.findIndex(x => x.IssueId == id);
    this.Detailtile = this.issueListAll[index].Title
    this.DetailDescription = this.issueListAll[index].Description != null ? this.issueListAll[index].Description : ''
    this.DetailStatus = this.issueListAll[index].IssueStatusCode != null ? this.issueListAll[index].IssueStatusCode : null
    this.DetailDateRaised = this.issueListAll[index].DateRaise != null ? this.formatDate(this.issueListAll[index].DateRaise) : null
    this.DetailDueDate = this.issueListAll[index].DueDate != null ? this.formatDate(this.issueListAll[index].DueDate) : null
    this.DetailRaiseBy = this.issueListAll[index].RaiseByCode != null ? this.issueListAll[index].RaiseByCode : null
    this.DetailActionOwner = this.issueListAll[index].IssueOwnerCode != null ? this.issueListAll[index].IssueOwnerCode : null
    this.DetailPriority = this.issueListAll[index].PriorityCode != null ? this.issueListAll[index].PriorityCode : null
    this.DetailSeverity = this.issueListAll[index].SeverityCode != null ? this.issueListAll[index].SeverityCode : null
    this.Detailtragetdate = this.issueListAll[index].TargetCompletionDate != null ? this.formatDate(this.issueListAll[index].TargetCompletionDate) : null
    this.DetailissueType = this.issueListAll[index].IssueTypeCode != null ? this.issueListAll[index].IssueTypeCode : null
    this.Detailhistoryprogress = this.issueListAll[index].CurrentProgress
    this.LoadIssueDocument(id);
    var displayfilename = this.issueListAll[index].FileName != null && this.issueListAll[index].FileName != '' && this.issueListAll[index].FileName != "undefined" ? this.issueListAll[index].FileName : null

  
    if (displayfilename != null && displayfilename != '') {
      this.Detailhtmldetailfile = '<a target="_blank" href = "/issue/downloadfileissue/' + id + '" >' + displayfilename + '</a>';

    } else {
      this.Detailhtmldetailfile = '';

    }
    this.hidIssueIddetail = this.issueListAll[index].IssueId

    $('#ModalDetailIssue').modal();
  }
  formatDate(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    } else {
      return null
    }
   
  }

  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }


  // validate custom
  checkdate(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const startcontrol = formGroup.controls[controlName];
      const endcontrol = formGroup.controls[matchingControlName];

      if (endcontrol.errors && !endcontrol.errors.checkdate) {
        return;
      }

      if ((startcontrol.value != '' && startcontrol.value != null) && (Date.parse(startcontrol.value) >= Date.parse(endcontrol.value))) {
        endcontrol.setErrors({ checkdate: true });
      } else {
        endcontrol.setErrors(null);
      }
    };
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }


  btnclickReadMore(traget) {
    if (traget.currentTarget.innerHTML == 'Read more') {
      $(traget.currentTarget).prev().css("max-height", "none");
      traget.currentTarget.innerHTML = 'Hide';
    } else {
      $(traget.currentTarget).prev().removeAttr("style");
      traget.currentTarget.innerHTML = 'Read more';
    }
  }


  btnclick_ExportExcel() {
    const onlyNameAndSymbolArr: Partial<IssueInfo>[] = this.issueListAll.map(x => ({
      'Issue Id': x.IssueId,
      'Title': x.Title,
      'Issue Status': x.IssueStatusName,
      'Issue Owner': x.IssueOwnerName,
      'Priority': x.PriorityName,
      'Severity': x.SeverityName,
      'Issue Type': x.IssueTypeName,
      'Current Progress': x.CurrentProgress != null && x.CurrentProgress != '' && x.CurrentProgress != 'null' ? $('<div>' + x.CurrentProgress.replace(/<br>/g, '\r\n') + '</div>')[0].innerText : '',
      'Due Date': this.formatDateExcel(x.DueDate),
      'File Name': x.FileName,
      'Date Raise': this.formatDateExcel(x.DateRaise),
      'Raise By': x.IssueOwnerName,
      'Target Completion Date': this.formatDateExcel(x.TargetCompletionDate)
    }));
    this.GlobalService.exportArrayToExcel(onlyNameAndSymbolArr, "IssueProject");
    
  }

  formatDateExcel(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [day, month, year].join('/');
    } else {
      return null
    }

  }

  LoadissueUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexissue = traget.index;
  }

  async UploadEventFilesToServer(files) {

    if (!files || files.length >= 6) {
      alert("Upload up to 5 files.")
      return false;
    }
    let filesToUpload: File[] = files;

    await Array.from(filesToUpload).map((file, index) => {
      // push uoload list
      const formData = new FormData();
      formData.append("pathfile", this.baselinePathFile);
      formData.append('file' + index, file, file.name);
      this.httpClient.post(this.baseurl + "api/upload", formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress) {
            var progress = Math.round(100 * event.loaded / event.total);

            if (progress == 100) {
            }

          } else if (event.type === HttpEventType.Response) {
          }
        });



    });

    return true;
  }

  DragFilesFinished(returnObj) {

    if (!!returnObj.Message) {
      alert(returnObj.Message)
    } else {
      this.baselineFilesToUpload = returnObj.Files;
      this.baselinePathFile = returnObj.PathFile;
    }
  }


  OnDeleteEventDocumentClick(elem) {
    alert("OK")

    let dataInfo = $(elem).parent().data();
    if (Object.keys(dataInfo).length > 0) {
      //Confirm to delete
      this.modalDocInfo = dataInfo;
      this.modalDocName = dataInfo.documentname;
      $('#ModalConfirmDeleteDoc').modal();
    }
  }

  async DeleteDocument() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentIssuePageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['IssueDocumentId'] = this.modalDocInfo.documentid;
      objectjson['IssueId'] = this.modalDocInfo.issueid;

      let strjson = JSON.stringify(objectjson);
      this.httpClient
        .post<boolean>(this.baseurl + "IssueDocument/DeleteIssueDocument",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if (data) {
              this.titlemodal = "Success";
              this.detailmodal = "The document has been deleted."
              $('#modalEventController').modal('hide');
              this.LoadIssue();
            } else {
              this.titlemodal = "Sorry";
              this.detailmodal = "Delete fail."
            }

            $('#ModalResult').modal();
          },
          error: error => {
            console.error('There was an error!', error);
          }
        })
    }
  }
  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#txtEventSubject").prop('disabled', true);
      $("#txtEventStartDate").prop('disabled', true);
      $('#txtEventStartTime').prop('disabled', true);
      $('#txtEventEndDate').prop('disabled', true);
      $('#txtEventEndTime').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#txtEventSubject").removeAttr('disabled');
      $("#txtEventStartDate").removeAttr('disabled');
      $('#txtEventStartTime').removeAttr('disabled');
      $('#txtEventEndDate').removeAttr('disabled');
      $('#txtEventEndTime').removeAttr('disabled');
      $('#modalEventController').modal('hide');
    }

  }

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }

  empselect(num) {
    this.employeeselectrun = true;
    this.employeeselectreturnto = num;
    this.selectedemp = null;

    console.log(this._ParamProjectCode)

    $('#ModalEmpSelect').modal();
  }

  async saveEmpSelect() {
    //if (this.AssignPMForm.valid) {
    if (this.selectedemp != null) {
      // hide modal Assign PM
      $('#ModalEmpSelect').modal('hide');
      this.employeeselectrun = false;

      if (this.employeeselectreturnto == '1') {
        this.ddlRaiseby = this.selectedemp.EmpCode;
      } else if (this.employeeselectreturnto == '2') {
        this.ddlIssueOwner = this.selectedemp.EmpCode;
      }

      this.selectedemp = null;

    } else {
      alert("Please select an employee")
    }

  }
}
